import React, { Component } from 'react';
//inutile
// export default class Price extends Component {
//   constructor(props) {
//     super(props);
//     this.calculer = this.calculer.bind(this)
//     this.state = {
//     };
//   }
//   calculer(){
//     let total = this.props.pricing.find((item)=> item.typededemande_id==this.props.typededemande && item.typedebien_id==this.props.typedebien).price
//     this.props.pieces.map((piece,index)=>{
//       total += this.props.pricingPiece.find((item)=> item.typedepiece_id==piece.id &&item.typededemande_id==this.props.typededemande && item.typedebien_id==this.props.typedebien).price * piece.quantite
//     })
//   }
//   render() {
//     return (
//       <div></div>
//     );
//   }
// }
